import {
  ActionApiType,
  AutomationRuleActionsEnum,
} from 'src/editor/shared/types/automation-rules/actions-types'

export const getAutomationRuleActionsFromApi = (action: ActionApiType) => {
  switch (action.type) {
    case AutomationRuleActionsEnum.remove_tag:
    case AutomationRuleActionsEnum.add_tag:
      return {
        id: action.id,
        type: action.type,
        tag: action.tag,
      }
    case AutomationRuleActionsEnum.subscribe_to_campaign:
    case AutomationRuleActionsEnum.unsubscribe_from_campaign:
      return {
        id: action.id,
        type: action.type,
        campaign: action.campaign,
      }
    case AutomationRuleActionsEnum.send_email:
      return {
        id: action.id,
        type: action.type,
        systemeEmail: action.systemeEmail,
      }
    case AutomationRuleActionsEnum.send_email_to_specific_address:
      return {
        id: action.id,
        type: action.type,
        emailMessageWithRecipient: {
          id: action.emailMessageWithRecipient.id,
          mailing: {
            currentEmail: action.emailMessageWithRecipient.mailing.currentEmail,
          },
        },
      }
    case AutomationRuleActionsEnum.revoke_access_to_course:
      return {
        id: action.id,
        type: action.type,
        course: action.course,
      }
    case AutomationRuleActionsEnum.enroll_in_course:
      return {
        id: action.id,
        type: action.type,
        course: action.course,
        courseAccessType: action.accessType,
      }
    case AutomationRuleActionsEnum.revoke_access_to_course_bundle:
      return {
        id: action.id,
        type: action.type,
        courseBundle: action.courseBundle,
      }
    case AutomationRuleActionsEnum.enroll_in_course_bundle:
      return {
        id: action.id,
        type: action.type,
        courseBundle: action.courseBundle,
        enrollmentAccessType: action.enrollmentAccessType,
      }
    case AutomationRuleActionsEnum.send_webhook:
      return {
        id: action.id,
        type: action.type,
        webhookUrl: action.webhookUrl,
      }
    case AutomationRuleActionsEnum.grant_access_to_community:
      return {
        id: action.id,
        type: action.type,
        community: action.community,
      }
    case AutomationRuleActionsEnum.revoke_access_to_community:
      return {
        id: action.id,
        type: action.type,
        community: action.community,
      }
    case AutomationRuleActionsEnum.create_user:
      return {
        id: action.id,
        type: action.type,
        locale: action.locale,
      }
    default:
      break
  }
  return
}
